/* import __COLOCATED_TEMPLATE__ from './company-billing-invoice-settings.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

const INVOICE_NET_STEP = 1;
const YES_OPTION_LABEL = 'YES';
const NO_OPTION_LABEL = 'NO';

const YES_NO_OPTION_LABELS = {
  0: NO_OPTION_LABEL,
  1: YES_OPTION_LABEL,
};

const YES_NO_OPTIONS = [
  {
    key: YES_NO_OPTION_LABELS[1],
    model: 1,
  },
  {
    key: YES_NO_OPTION_LABELS[0],
    model: 0,
  },
];

class AdminCompanyBillingInvoiceSettings extends Component {
  get billingDefaults() {
    const { companyBillingDefaults, companyTierVersion, companyTier } = this.args;
    return companyBillingDefaults[companyTierVersion][companyTier];
  }

  get booleanOptions() {
    return YES_NO_OPTIONS;
  }

  get booleanOptionLabels() {
    return YES_NO_OPTION_LABELS;
  }

  get invoiceNetStep() {
    return INVOICE_NET_STEP;
  }

  get onInvoiceValue() {
    return Number(this.args.currentValues.onInvoice);
  }

  get invoiceNetValue() {
    return this.args.currentValues.invoiceNet ?? this.billingDefaults.invoiceNet;
  }

  get autochargeValue() {
    return Number(this.args.currentValues.autocharge);
  }

  get subjectToDelinquentFees() {
    return Number(this.delinquentFee) > 0;
  }

  get delinquentFee() {
    return this.args.currentFees.delinquentFee ?? this.billingDefaults.delinquentFee * 100;
  }

  @action
  handleDelinquentCheckbox() {
    const newDelinquentFee = this.delinquentFee > 0
      ? 0
      : this.billingDefaults.delinquentFee * 100;

    this.args.onChangeFee('delinquentFee', newDelinquentFee);
  }
}

export default AdminCompanyBillingInvoiceSettings;
